// extracted by mini-css-extract-plugin
export default {"options":"Options_options__zgXOu"};